export const PROMO_COOLDOWN_DAYS = 14;
export const COOKIE_VERSION = "cookie-policy-2026-09";

export const STORAGE_KEYS = {
  theme: "slot-theme",
  cookieConsent: "slot-cookie-consent",
  promoSeen: "slot-promo-seen",
} as const;

export const THEME_COOKIE = "slot-theme";

export type Theme = "light" | "dark";

export type CookieConsent = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  version: string;
  date: string;
};
